import React from 'react';
import { Card, CardContent, Typography, Chip, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

type GapCardProps = {
  control: string;
  status: 'Compliant' | 'NonCompliant' | 'Partial';
  priority: 'Critical' | 'High' | 'Medium' | 'Low';
  findings: number;
  onClick: () => void;
};

export default function GapCard({
  control,
  status,
  priority,
  findings,
  onClick
}: GapCardProps) {
  const theme = useTheme();
  
  const statusColor = {
    Compliant: theme.palette.success.main,
    NonCompliant: theme.palette.error.main,
    Partial: theme.palette.warning.main
  };

  return (
    <Card 
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
      sx={{ 
        mb: 2,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        '&:hover': { 
          boxShadow: 4,
          transform: 'translateY(-2px)',
          backgroundColor: 'action.hover'
        },
        '&:active': {
          transform: 'translateY(0)'
        }
      }}
    >
      <CardContent>
        <Typography variant="h6">{control}</Typography>
        <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
          <Chip 
            label={status} 
            size="small"
            sx={{ 
              backgroundColor: statusColor[status],
              color: 'white',
              pointerEvents: 'none'
            }}
          />
          <Chip 
            label={`${findings} findings`} 
            size="small"
            sx={{ pointerEvents: 'none' }}
          />
          <Chip 
            label={priority} 
            size="small" 
            color={priority === 'Critical' ? 'error' : 'primary'}
            sx={{ pointerEvents: 'none' }}
          />
        </Box>
      </CardContent>
    </Card>
  );
}
